import moment from 'moment'

import { OPTIONS_FILTERS_ENUM_TYPES } from './options'

/**
 *  Get diff
 * @param {number} value
 * @param {number} previousValue
 * @return {number} diff between values
 */
export const getPeriodDiff = (value, previousValue) => {
  if (previousValue === 0) {
    return 100
  }
  return (value / previousValue) * 100 - 100
}
/**
 *  Get value is positive
 * @param {number} value
 * @return {boolean} isPositive
 */
export const getIsPositive = value => value >= 0

/**
 *  Get past date depending on the filter
 * @param {number} date
 * @param {string} type
 * @return {number} past date
 */
export const getPastDates = (date, type) => {
  switch (type) {
    case OPTIONS_FILTERS_ENUM_TYPES.LAST_DAY:
      return moment(date)
        .subtract(1, 'day')
        .valueOf()
    case OPTIONS_FILTERS_ENUM_TYPES.LAST_2_DAYS:
      return moment(date)
        .subtract(2, 'day')
        .valueOf()
    case OPTIONS_FILTERS_ENUM_TYPES.LAST_7_DAYS:
      return moment(date)
        .subtract(7, 'day')
        .valueOf()
    case OPTIONS_FILTERS_ENUM_TYPES.LAST_2_WEEKS:
      return moment(date)
        .subtract(2, 'week')
        .valueOf()
    case OPTIONS_FILTERS_ENUM_TYPES.LAST_1_MONTH:
      return moment(date)
        .subtract(1, 'month')
        .valueOf()
    case OPTIONS_FILTERS_ENUM_TYPES.LAST_2_MONTH:
      return moment(date)
        .subtract(2, 'month')
        .valueOf()
    case OPTIONS_FILTERS_ENUM_TYPES.LAST_6_MONTH:
      return moment(date)
        .subtract(6, 'month')
        .valueOf()
    case OPTIONS_FILTERS_ENUM_TYPES.LAST_1_YEAR:
      return moment(date)
        .subtract(1, 'year')
        .valueOf()
    case OPTIONS_FILTERS_ENUM_TYPES.LAST_2_YEAR:
      return moment(date)
        .subtract(2, 'year')
        .valueOf()
    default:
      return moment(date)
        .subtract(7, 'day')
        .valueOf()
  }
}



// WEBPACK FOOTER //
// ./src/Containers/StatsOverview/components/CampaignPerforming/Charts/utils.js